import React from 'react'
import { Channel } from '@ztechapps/chat.webui'
import { useContext } from './Context'
import { SendMessageButton } from '@ztechapps/chat.webui'
import { useUser } from '../../hooks/useUser'
import { useSendCustomerChatReply } from '@ztechapps/chat.common'

export const CommunicationTab = () => {
  const { document } = useContext()
  const conversationId = document?.activeConversationId
  const subject = `Panelpunches Order #${document?.code}`
  const user = useUser()

  const components = {
    sendMessageButton: SendMessageButton,
  }

  const sendChatMessageResult = useSendCustomerChatReply()

  return (
    <Channel
      recipient={user?.user?.profile}
      components={components}
      conversationId={conversationId}
      subject={subject}
      members={document?.members}
      hideFormalizeButton
      sendChatMessageResult={sendChatMessageResult}
    />
  )
}
